import clickOutside from 'src/directives/click-ouside.js';
import fitText from 'src/directives/fit-text.js';
import twinSrc from 'src/directives/twinSrc.js';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive('click-outside', clickOutside);
    Vue.directive('fit-text', fitText);
    Vue.directive('twin-src', twinSrc);
  }
};

export default GlobalDirectives;
